import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import { TestingApp } from './TestingApp';

ReactDOM.render(
    <TestingApp />,
  document.getElementById('root')
);